import React, { Fragment } from "react";
import sad from "../../assets/images/other-images/sad.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Error404 = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <div className="page-wrapper">
        {/* <!-- error-404 start--> */}
        <div className="error-wrapper">
          <div className="container">
            <img className="img-100" src={sad} alt="" />
            <div className="error-heading">
              <h2 className="headline font-danger">{"404"}</h2>
            </div>
            <div className="col-md-8 offset-md-2">
              <p className="sub-content">{t("error_404")}</p>
            </div>
            <div>
              <Link
                to="/dashboard"
                className="btn btn-danger-gradien"
              >
                {t("back_to_home")}
              </Link>
            </div>
          </div>
        </div>
        {/* <!-- error-404 end--> */}
      </div>
    </Fragment>
  );
};

export default Error404;
